import { OnInit, Component, Input, ViewEncapsulation, Renderer2 } from '@angular/core';
import * as bowser from 'bowser';
import { ObservablesService } from 'src/app/Services/observables/observables';

@Component({
	selector: 'under-written',
	encapsulation: ViewEncapsulation.None,
	template: `
		<div class="close-box">
			<button class="icon icon-close" (click)="close()"></button>
		</div>
		<div>
			<div class="logo">
				<img *ngIf="modal.data.carrierName !== 'ASI'" class="prog-home-logo" [src]="modal.data.proglogo" />
				<img
					[ngClass]="{
						asi: modal.data.carrierName === 'ASI',
						'img-src': modal.data.carrierName !== 'ASI',
						'plymout-rock-logo': modal.data.carrierName === 'PlymouthRock'
					}"
					[src]="modal.data.imageSrc"
				/>
			</div>
			<div class="content" [innerHtml]="modal.data.expandedText"></div>
		</div>
	`,
	styleUrls: ['./under-written.component.scss'],
})
export class UnderWrittenComponent implements OnInit {
	@Input() modal;
	@Input() closeModal;
	@Input() modalRef;
	private removeKeydownListener: () => void;

	constructor(private observablesService: ObservablesService, private renderer: Renderer2) {}

	ngOnInit() {
		if (this.modal.data) {
			// This function makes sure the relevant modal css is loaded before rendering the modal
			setTimeout(() => {
				var backdropModalElem = document.getElementsByClassName('modal-backdrop')[0];
				backdropModalElem.classList.add('underwritten-modal-backdrop');
				var modalElem = document.getElementsByClassName('modal')[0];
				modalElem.classList.add('underwritten-modal');
				this.removeKeydownListener = this.renderer.listen('document', 'keydown', (e) => {
					if (e.keyCode === 27)
						// ESC key
						this.keyDownEventListener(e);
				});
				//this.renderer.addEventListener('keydown', (event) => this.keyDownEventListener.bind(this));
				var modalContentHtmlElem = document.getElementsByClassName('modal-content')[0] as HTMLElement;
				modalContentHtmlElem.style.display = 'block';

				const isMobile =
					bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
					bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';
				if (isMobile) {
					modalElem.classList.add('mobile');
				}
				// Scroll to top
				window.scrollTo(0, isMobile ? 180 : 1000);
			}, 0);
		}
	}

	keyDownEventListener(event) {
		if (event.key === 'Escape') {
			event.preventDefault();
			this.close();
		}
	}

	ngAfterViewInit() {
		var modalContentHtmlElem = document.getElementsByClassName('modal-content')[0] as HTMLElement;
		modalContentHtmlElem.style.display = 'none';
	}

	close() {
		this.closeModal();
		if (this.removeKeydownListener) {
			this.removeKeydownListener();
		}
		//this.modalElem.removeEventListener('keydown', this.keyDownEventListener, false);
	}
}
